import { useSlideTimer } from '@/features/HomepageHero/useSlideTimer';
import { cn } from '@/lib/utils';

type Props = {
  isActive: boolean;
};

const HeroProgressBar = ({ isActive }: Props) => {
  const { timerKey } = useSlideTimer();
  return (
    <div className='h-[3px] relative w-full'>
      <div className='h-full absolute top-0 left-0 bg-gray-dark-800 w-full' />

      {isActive && (
        <div
          key={`timer-${timerKey}`}
          className={cn(
            'absolute top-0 left-0 w-0',
            'bg-gradient-secondary-4 hidden h-full md:flex',
            'animate-grow-width-9s'
          )}
        />
      )}
    </div>
  );
};

export default HeroProgressBar;
